<template>
    <!--  报表导出弹窗 -->
    <div>
        <a-modal
        centered
        title='导出记录'
        :visible="visible"
        :width="1200"
        :destroyOnClose="true"
        @cancel="close"
        :maskClosable="false"
        :footer="false"
        >
            <div class="flex flex-space-between mb16">
                <span v-if="isAdmin && ($route.name == 'userTicket' || $route.name == 'ticketVerifyRecord')" class="text-fail">*您当前为超级管理员角色，可导出不加密的用户手机号，请自觉遵守《个人信息保护法》及本公司保密条例等相关规定！</span>
                <span v-else></span>
                <a-button @click="refresh" type="primary" :loading="loading">刷新</a-button>
            </div>
            <a-table
            bordered
            :columns="columns"
            :pagination="pagination"
            :dataSource="dataSource"
            :rowKey="i => i.index"
            :loading="loading"
            @change="changePage"
            >
                <template slot="isEmpty" slot-scope="key">{{key | isEmpty}}</template>
                <template slot="exportState" slot-scope="key">{{['', '成功', '导出中', '失败'][key]}}</template>
                <template slot="active" slot-scope="key, row">
                    <a v-if="!row.exportDownloadTime && row.exportUser === loginInfo.name && row.exportState === 1" class="text-primary" @click="download(key, row)">下载</a>
                    <span v-else>--</span>
                </template>
            </a-table>
        </a-modal>
    </div>
</template>

<script>
    /**
     * 报表导出弹窗
     *
     * @func close 关闭回调
     *
     */
    const columns = [
        {
            title: 'No',
            dataIndex: 'index',
            width: 70
        },
        {
            title: '下载内容',
            dataIndex: 'exportFileName',
            width: 250
        },
        {
            title: '状态',
            dataIndex: 'exportState',
            scopedSlots: {customRender: 'exportState'}
        },
        {
            title: '创建人',
            dataIndex: 'exportUser'
        },
        {
            title: '导出',
            dataIndex: 'exportTime'
        },
        {
            title: '下载用户',
            dataIndex: 'exportDownloadUser',
            scopedSlots: {customRender: 'isEmpty'}
        },
        {
            title: '下载时间',
            dataIndex: 'exportDownloadTime',
            scopedSlots: {customRender: 'isEmpty'}
        },
        {
            title: '操作',
            dataIndex: 'id',
            width: 70,
            scopedSlots: {customRender: 'active'}
        },
    ];
    export default {
        name: "report-export-modal",
        zh: "报表导出弹窗",
        components: {},
        props: {
            exportType: {
                type: Number,
                default: null
            }
        },
        data() {
            return {
                columns,
                visible: false,
                loading: false,
                pagination: {
                    showTotal: total => `共 ${total} 条数据`,
                    showSizeChanger: false,
                    showQuickJumper: false,
                    total: 0,
                    current: 1,
                    pageSize: 10
                },
                dataSource: [],
                timer: null,
                isAdmin: false, //当前登录角色是否为超级管理员
            };
        },
        computed: {
        },
        watch: {
        },
        methods: {
            open() {
                this.visible = true;
                this.exportRecord();
                this.timerGatExportRecord();
            },
            close() {
                clearTimeout(this.timer);
                this.visible = false;
                setTimeout(() => {
                    this.pagination.total = 0;
                    this.pagination.current = 1;
                    this.pagination.pageSize = 10;
                }, 300);
                if (!this.$listeners.close) {
                    return false;
                }
                this.$emit('close');
            },
            exportRecord() {
                this.$api.order.exportRecord({
                    body: {
                        exportType: this.exportType,
                        operateShopId: this.loginInfo.shopIdList[0],
                        pageNum: this.pagination.current,
                        pageSize: this.pagination.pageSize
                    }
                }).then(res => {
                    this.loading = false;
                    if (res && res.list) {
                        this.pagination.total = res.total;
                        res.list.forEach((i, index) => i.index = index + 1);
                        this.dataSource = res.list;
                    }
                }).catch(err => {
                    this.loading = false;
                });
            },
            timerGatExportRecord() {
                this.timer = setTimeout(() => {
                    this.timerGatExportRecord();
                    let hasExporting = this.dataSource.find(i => i.exportState === 2);
                    if (hasExporting) {
                        if (this.loading) {
                            return false;
                        }
                        this.exportRecord();
                    }
                }, 1000);
            },
            refresh() {
                if (this.loading) {
                    return false;
                }
                this.loading = true;
                this.exportRecord();
            },
            changePage(page) {
                this.loading = true;
                this.pagination.current = page.current;
                this.exportRecord();
            },
            download(id, row) {
                if (this.loading) {
                    return false;
                }
                this.loading = true;
                this.$api.order.exportDownload({
                    body: {
                        id,
                        exportDownloadUser: this.loginInfo.name
                    }
                }).then(res => {
                    this.loading = false;
                    this.$message.success('操作成功！');
                    this.downloadFile(row);
                    this.refresh();
                }).catch(err => {
                    this.loading = false;
                });
            },
            downloadFile({exportUrl, exportFileName}) {
                let a = document.createElement('a');
                a.href = exportUrl;
                a.download = exportFileName;
                a.click();
            }
        },
        mounted() {
            this.isAdmin = this.loginInfo.roleIdList.indexOf('1') > -1;
        },
        beforeCreate() {
            this.loginInfo = this.$userInfoTool.getUser();
        },
        beforeDestroy() {
            clearTimeout(this.timer);
        }
    };
</script>

<style lang="scss">
.fail-tips {
    position: absolute;
    bottom: 46px;
}
</style>
